/**
 * 徽章等级 / 积分：统一收成非负整数。
 * 表单 validate、完成度、buildExtaPayload 共用，避免三处口径漂移。
 *
 * @param {*} value 运营输入（number / 数字字符串 / 空）
 * @returns {number|null} 合法非负整数；空 / 小数 / 非数字返 null
 */
export function parseNonNegativeInt(value) {
  if (value === '' || value === null || value === undefined) {
    return null
  }
  const num = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(num) || !Number.isInteger(num) || num < 0) {
    return null
  }
  return num
}

export function isNonNegativeInt(value) {
  return parseNonNegativeInt(value) != null
}
